import { CustomTableHeader } from '../CustomTable';
import BolinhaTabelaStatus from '../bolinhaTabelaStatus';

export const renderStatusDot = (value: unknown) => {
  const isActive = value === true || value === 'Ativo';
  return <BolinhaTabelaStatus status={isActive ? 'S' : 'N'} />;
};
export type UsuariosTableRow = {
  id: string | number;
  stRegistroAtivo: boolean;
  nomeCompleto: string;
  UnidadeCadastro: string;
  papel: string;
  emailPessoal: string;
  [key: string]: any;
};
export const headersListaUsuarios: CustomTableHeader<UsuariosTableRow>[] = [
  { text: '', width: 2, key: '', renderable: false },
  { text: 'ID', width: 5, key: 'id', fieldType: 'number', textAlign: 'center' },
  {
    text: 'Status',
    width: 5,
    key: 'stRegistroAtivo',
    renderCell: (value) => renderStatusDot(value),
    fieldType: 'select',
  },
  { text: 'Usuário', width: 15, key: 'nomeCompleto' },
  {
    text: 'Setor DAF, SES ou Fornecedor',
    width: 20,
    key: 'UnidadeCadastro',
  },
  { text: 'Papel', width: 10, key: 'papel', fieldType: 'select' },
  { text: 'Interface', width: 10, key: 'interface', fieldType: 'select' },
  { text: 'Email Pessoal', width: 15, key: 'emailPessoal' },
];
